/**
 * RSVP API Module - Issue #318
 * 
 * API functions for event RSVP management
 */

import { apiGet, apiPost } from '../api';

export type RSVPStatus = 'yes' | 'no' | 'maybe';

export interface EventRSVP {
  id: string;
  event_id: string;
  user_id: string;
  status: RSVPStatus;
  created_at: number;
  updated_at: number;
  notes?: string;
}

export interface CreateRSVPRequest {
  status: RSVPStatus;
  notes?: string;
}

export interface RSVPResponse {
  rsvp: EventRSVP;
}

export interface RSVPListResponse {
  rsvps: EventRSVP[];
  counts: {
    yes: number;
    no: number;
    maybe: number;
    total: number;
  };
}

/**
 * RSVP API functions
 */
export const rsvpsApi = {
  /**
   * Get user's RSVP for a specific event
   */
  getUserRSVP: (eventId: string): Promise<RSVPResponse> => {
    return apiGet<RSVPResponse>(`/events/${eventId}/rsvp/me`);
  },

  /**
   * Get all RSVPs for an event with counts
   */
  getEventRSVPs: (eventId: string): Promise<RSVPListResponse> => {
    return apiGet<RSVPListResponse>(`/events/${eventId}/rsvps`);
  },

  /**
   * Create or update an RSVP
   */
  createRSVP: (eventId: string, data: CreateRSVPRequest): Promise<RSVPResponse> => {
    return apiPost<RSVPResponse>(`/events/${eventId}/rsvp`, data);
  },
};